<template>
    <h4 :class="listStyle === 'dot' ? 'dot' : ''">
        <slot></slot>
    </h4>
</template>
<script>
export default {
    props: {
        listStyle: {},
    },
};
</script>
<style lang="scss" scoped>
h4 {
    font-family: "Pretendard", sans-serif;
    font-size: 28px;
    color: var(--black1);
    letter-spacing: -0.025em;
    font-weight: 700;
    margin-bottom: 60px;

    &.dot {
        position: relative;
        padding-left: 30px;

        &::after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            border-radius: 10px;
            background: var(--orange);
            top: calc(1ch - 7px);
            left: 0;
        }
    }

    @media screen and (max-width: 768px) {
        font-size: 22px;
        margin-bottom: 30px;
    }
}
</style>
